import dayjs from 'dayjs';
import { formatDate } from 'src/_shared/services/utils.js';

export const createLogMessage = (
	userEmail,
	payment,
	change,
	reasonForChange = ''
) => {
	let changeLog = `${userEmail} updated the ${change} on payment "${payment}"`;
	if (reasonForChange) changeLog += ` with the reason "${reasonForChange}"`;
	return changeLog;
};

export const generateBonusLogs = (
	originalBonus,
	updatedFields,
	userEmail,
	reasonForChange = ''
) => {
	const currentDate = dayjs().toISOString();
	const logArray = [];

	const normalFormat = (value) =>
		value === 'earned' ? `"eligible"` : `"${value}"`;
	const dateFormat = (value) => `"${value ? formatDate(value) : 'undefined'}"`;

	const fieldsToCheck = [
		{
			key: 'amountDue',
			newValue: updatedFields.amountDue,
			label: 'bonus amount',
			formatter: normalFormat,
		},
		{
			key: 'startDate',
			newValue: updatedFields.startDate,
			label: 'start date',
			formatter: dateFormat,
		},
		{
			key: 'earnedDate',
			newValue: updatedFields.earnedDate,
			label: 'eligible date',
			formatter: dateFormat,
		},
		{
			key: 'paidDate',
			newValue: updatedFields.paidDate,
			label: 'paid date',
			formatter: dateFormat,
		},
		{
			key: 'bonusStatus',
			newValue: updatedFields.bonusStatus,
			label: 'status',
			formatter: normalFormat,
		},
		{
			key: 'notes',
			newValue: updatedFields.notes || null,
			label: 'bonus notes',
			formatter: normalFormat,
		},
		{
			key: 'ignoreEligibilityChecks',
			newValue: updatedFields.ignoreEligibilityChecks,
			label: 'ignore eligibility checks value',
			formatter: normalFormat,
		},
		{
			key: 'currency',
			newValue: updatedFields.currency,
			label: 'currency',
			formatter: normalFormat,
		},
	];

	for (const { key, newValue, label, formatter } of fieldsToCheck) {
		const oldValue =
			key === 'notes' && originalBonus[key] === '' ? null : originalBonus[key];
		if (newValue !== oldValue) {
			logArray.push({
				date: currentDate,
				changeLog: createLogMessage(
					userEmail,
					originalBonus.payment,
					`${label} to ${formatter(newValue)}`,
					reasonForChange
				),
			});
		}
	}

	return logArray;
};
